import React from "react";
import { Layout } from "components";
import Hero from "./Hero";
import About from "./About";
import ContentSlider from "./ContentSlider";
import { Container } from "react-bootstrap";

export default function Home() {
  return (
    <Layout layout2>
      <div id="home_page" className="page_container pt-5">
        {/* Test <Test /> */}

        {/* Hero */}
        <Hero />

        {/* About */}
        <About />

        {/* Content Slider */}
        <ContentSlider />
      </div>
    </Layout>
  );
}

const Test = () => {
  const [text, setText] = React.useState([]);

  const test = (comm, lines) => {
    const myLines = lines.map((item) =>
      item
        .split("")
        .filter((item) => item !== "(" && item !== ")")
        .join("")
    );
    const myComment = comm
      .split("")
      .filter((item) => item !== "(" && item !== ")")
      .join("");
    for (let i = 0; i < lines.length; i++) {
      if (myLines[i] && myComment) {
        try {
          let position = myLines[i].search(myComment);
          if (position >= 0) {
            lines[i] = ";lkjhgfdxxcvbn";
            return i + 1;
          }
        } catch {}
      }
    }
  };
  function compare(a, b) {
    if (a.line < b.line || !a.line || !b.line) {
      return -1;
    }
    if (a.line > b.line) {
      return 1;
    }
    return 0;
  }
  return (
    <Container>
      <textarea
        className="w-100"
        onChange={(event) => {
          const lines = event.target.value?.split("\n");
          const oneLineComm = event.target.value
            ?.split("//")
            .map((item) => item.split("\n")[0])
            .slice(1)
            .map((item) => ({ text: item, line: test(item, lines) }));
          const twoLineComm = event.target.value
            ?.split("/*")
            .map((item) => item.split("*/")[0])
            .slice(1)
            .map((item) => ({ text: item, line: test(item, lines) }));

          setText([...twoLineComm, ...oneLineComm]);
        }}
      ></textarea>
      <p>
        {text
          .filter((item) => item.line)
          ?.sort(compare)
          .map((item, index) => (
            <>
              Line {item.line}:{item.text} <br />
            </>
          ))}
        {text
          .filter((item) => !item.line)
          ?.sort(compare)
          .map((item, index) => (
            <>
              Line {item.line}:{item.text}
              <br />
            </>
          ))}
      </p>
    </Container>
  );
};
